import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RouteArr from "../configuration/getRoutes";
import Main from "../pages/main";
import Login from "../pages/login"
import { ClaimStatus, Quickpay } from "../pages";

const router = createBrowserRouter([
  {
    path: "/", // Main layout path
    element: <Main />, // Apply layout to all routes
    children: RouteArr,
  },
  {
    name: "login",
    path: "/login",
    key: "login",
    route: "/login",
    element: <Login />,
  },
  {
    name: "Quickpay",
    path: "/quickpay",
    key: "quickpay",
    route: "/quickpay",
    element: <Quickpay />,
  },
  {
    name: "Claim Status",
    path: "/claimstatus",
    key: "claimstatus",
    route: "/claimstatus",
    element: <ClaimStatus/>,
  },
]);
const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
